import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import { MouseEvent } from 'react';

import styles from './PostfixPopupLink.css';
import { UIText2 } from '@cian/ui-kit';

interface IPostfixPopupLinkProps {
  href: string;
  text: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export const PostfixPopupLink: React.FC<IPostfixPopupLinkProps> = ({ text, href, onClick }) => {
  const handleClick = onClick
    ? (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onClick(event);
      }
    : undefined;

  return (
    <a href={href} className={styles['container']} onClick={handleClick}>
      <span className={styles['text']}>
        <UIText2 color="text-main-default">{text}</UIText2>
      </span>
      <IconActionArrowUpRight16 color="icon-main-default" />
    </a>
  );
};
